module.exports = __webpack_public_path__ + "static/media/onboarding-4.b4c2aada.png";